import { isAddress } from "viem";
import { mainnet, sepolia } from "viem/chains";

export type HexAddress = `0x${string}`;

export const ZERO_ADDRESS: HexAddress = "0x0000000000000000000000000000000000000000";

export const ADDRESS_ENV = {
  nft: "VITE_CODE_APE_NFT_ADDRESS",
  claimVault: "VITE_CLAIM_VAULT_ADDRESS",
  hook: "VITE_CODE_APE_HOOK_ADDRESS",
  capeToken: "VITE_CAPE_CONTRACT_ADDRESS"
} as const;

export function envString(envName: string): string | null {
  const value = import.meta.env[envName] as string | undefined;
  const trimmed = typeof value === "string" ? value.trim() : "";
  return trimmed || null;
}

export const EXPECTED_CHAIN_ID = Number(envString("VITE_CHAIN_ID") ?? "1");
export const EXPECTED_CHAIN = EXPECTED_CHAIN_ID === sepolia.id ? sepolia : mainnet;
export const EXPECTED_CHAIN_LABEL = EXPECTED_CHAIN_ID === sepolia.id ? "Sepolia" : "Ethereum Mainnet";
export const EXPECTED_CHAIN_ID_BIGINT = BigInt(EXPECTED_CHAIN.id);
export const EXPECTED_CHAIN_ID_HEX = `0x${EXPECTED_CHAIN.id.toString(16)}`;

const MAINNET_DEFAULT_ADDRESSES: Record<string, HexAddress> = {
  [ADDRESS_ENV.nft]: "0xfFbA7FB7D845E01A1563522499aC8C5BE40C3461",
  [ADDRESS_ENV.claimVault]: "0x0Cd62E98B0C5B18a99669465cbbc27d6a63Ae337",
  [ADDRESS_ENV.hook]: "0x10DcF68882b00FA300D7a30f14a2A24bC46de0CC",
  [ADDRESS_ENV.capeToken]: "0x84B3eb1Ee2694c4f18712949c80B2922deD4C079"
};

export function envAddress(envName: string): HexAddress | null {
  const value = envString(envName);
  if (value && isAddress(value) && value.toLowerCase() !== ZERO_ADDRESS) return value as HexAddress;
  if (EXPECTED_CHAIN_ID === mainnet.id) return MAINNET_DEFAULT_ADDRESSES[envName] ?? null;
  return null;
}

export function requireEnvAddress(envName: string): HexAddress {
  const value = envAddress(envName);
  if (!value) {
    throw new Error(`${envName} is not configured. This UI is not ready for contract writes.`);
  }
  return value;
}

export function hasAllRequiredContractAddresses(): boolean {
  return Boolean(
    envAddress(ADDRESS_ENV.nft) &&
    envAddress(ADDRESS_ENV.claimVault) &&
    envAddress(ADDRESS_ENV.hook)
  );
}
